import { Dispatch, SetStateAction, useState } from 'react';
import { Column } from 'primereact/column';
import { DataTable, DataTableValueArray } from 'primereact/datatable';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { InputSwitch } from 'primereact/inputswitch';

interface RowDataType {
    key: string,
    name: string,
    description: string,
    enabled: boolean,
    createdAt: string,
    updatedAt: string
}

interface flageType {
    setFlagArray: Dispatch<SetStateAction<DataTableValueArray>>;
    flagArray: any;
    // flagArray: DataTableValueArray;
    filters: { [s: string]: any; } | undefined
}

const FeatureFlagDataTable = ({ flagArray, setFlagArray, filters }: flageType) => {

    const onToggle = (rowData: RowDataType) => {
        const updatedData = flagArray.map((item: any) =>
            item.key === rowData.key ? { ...item, enabled: !item.enabled } : item
        );
        setFlagArray(updatedData);
    };

    const switchTemplate = (rowData: RowDataType) => {
        return (
            <InputSwitch checked={rowData.enabled} onChange={() => onToggle(rowData)} />
        );
    };

    return (
        <div key={flagArray}>
            <div className='datatable-wrapper'>
                <DataTable
                    scrollable
                    filters={filters}
                    // scrollHeight="70vh"
                    stripedRows
                    value={flagArray}
                    tableStyle={{}}
                    emptyMessage="No options available"
                >
                    <Column field="name" header="Flag name" sortable></Column>
                    <Column
                        field="enabled"
                        header="Flag Permission"
                        body={switchTemplate}
                    ></Column>
                </DataTable>
            </div>
        </div>
    );
};

export default FeatureFlagDataTable;
